import { render, staticRenderFns } from "./addextPartner.vue?vue&type=template&id=6c9f99fa"
import script from "./addextPartner.vue?vue&type=script&lang=js"
export * from "./addextPartner.vue?vue&type=script&lang=js"
import style0 from "./addextPartner.vue?vue&type=style&index=0&id=6c9f99fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports